module.exports = __webpack_public_path__ + "static/reading-7358d2225be0fb5adb2888ab68846c04.svg";